// extracted by mini-css-extract-plugin
export default {"table_container":"ChangeTHsModal_table_container__-mo8Z"};